import { adjustmentCriteriaApi, expressionDefinitionApiV2 } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';

export const GET_ADJUSTMENT_SCHEMA_PARAMS = 'GET_ADJUSTMENT_SCHEMA_PARAMS';
export const GET_ADJUSTMENT_CRITERIA = 'GET_ADJUSTMENT_CRITERIA';
export const ADD_ADJUSTMENT_CRITERIA = 'ADD_ADJUSTMENT_CRITERIA';
export const EDIT_ADJUSTMENT_CRITERIA = 'EDIT_ADJUSTMENT_CRITERIA';
const DELETE_ADJUSTMENT_CRITERIA = 'DELETE_ADJUSTMENT_CRITERIA';

const criteria = new schema.Entity('criteria', {}, { idAttribute: 'criteriaId' });

export const getAdjustmentCriteriaAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await adjustmentCriteriaApi.getCriteria(params);

  return dispatch({
    type: GET_ADJUSTMENT_CRITERIA,
    payload: normalize(data, [criteria]).entities,
  });
});

export const addAdjustmentCriteriaAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await adjustmentCriteriaApi.createCriteria(params);

  return dispatch({
    type: ADD_ADJUSTMENT_CRITERIA,
    payload: data,
  });
});

export const editAdjustmentCriteriaAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await adjustmentCriteriaApi.editCriteria(params);

  return dispatch({
    type: EDIT_ADJUSTMENT_CRITERIA,
    payload: data,
  });
});

export const deleteAdjustmentCriteriaAction = catchAsyncActionError(params => async dispatch => {
  await adjustmentCriteriaApi.deleteCriteria(params);

  return dispatch({
    type: DELETE_ADJUSTMENT_CRITERIA,
  });
});

export const getAdjustmentSchemaParamsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await expressionDefinitionApiV2.getAdjustmentSchemaExpressionDefinition();

  return dispatch({
    type: GET_ADJUSTMENT_SCHEMA_PARAMS,
    payload: data,
  });
});
